import { axiosPrivate } from "../../util/axios";
import { LocationPros } from "../../types/baseTypes";

/**
 * Fetch locations filtered by service type (e.g., "keys").
 * Falls back to all locations when no service is provided.
 */
export async function fetchLocationsByService(service?: string): Promise<LocationPros[]> {
  const url = service ? `/location?services=${encodeURIComponent(service)}` : 
                         "/location";
  const { data } = await axiosPrivate.get<LocationPros[]>(url);
  return data;
}
